import React from 'react';
import { Control, Controller, useFieldArray, useFormState } from 'react-hook-form';
import { IDeliverForm } from '../types';
import GridRow from '../../../ui/GridRow';
import s from '../../../components/SeoKeywords/styles/seoKeywords.module.scss';
import Input from '../../../ui/Input';
import i18n from '../../../utils/i18n';
import Button from '../../../ui/Button';
import { ButtonVariationEnum } from '../../../ui/Button/types';
import Icon, { IconEnum } from '../../../ui/Icon';
import DottedButton from '../../../ui/DottedButton';
import Details from '../../../ui/Details/details';
import NotificationInline, { NotificationTypeEnum } from '../../../ui/NotificationInline';

interface IDeliveryConditions {
    control: Control<IDeliverForm>;
}

const FIELD_NAME = 'options';

const DeliveryConditions = ({ control }: IDeliveryConditions) => {
    const { fields, append, remove } = useFieldArray({
        control,
        name: FIELD_NAME,
        rules: { minLength: 1, required: true },
    });

    const { errors } = useFormState({
        control,
        name: FIELD_NAME,
        exact: true,
    });

    const hasError = errors[FIELD_NAME];

    return (
        <Details label={i18n.delivery.conditions} icon={IconEnum.DOCS} error={!!hasError}>
            <GridRow column gutter={8}>
                {fields?.map((item, idx) => (
                    <GridRow isFlex key={item.id}>
                        <Controller
                            name={`${FIELD_NAME}.${idx}.value`}
                            control={control}
                            rules={{ required: true }}
                            render={({ field: { onChange, value }, fieldState: { error } }) => (
                                <Input
                                    value={value}
                                    onChange={onChange}
                                    small
                                    className={s.inputField}
                                    label={i18n.general.description}
                                    error={!!error}
                                />
                            )}
                        />
                        <Button variation={ButtonVariationEnum.SIMPLE} isSmall onClick={() => remove(idx)}>
                            <Icon icon={IconEnum.DELETE} className={s.icon} />
                        </Button>
                    </GridRow>
                ))}
                {!!hasError?.root && (
                    <NotificationInline text={i18n.delivery.minConditions} type={NotificationTypeEnum.ERROR} />
                )}
                <DottedButton onClick={() => append({ value: '' })}>{i18n.general.add}</DottedButton>
            </GridRow>
        </Details>
    );
};

export default DeliveryConditions;
